import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';
import {
  storageBucket,
  subscribePublicIdentity,
  toPublicIdentity,
  windowTitle,
  type PublicIdentity,
  type PublicIdentityDoc,
} from './publicIdentity';

const VAZIA: PublicIdentity = { clinicName: null, logoUrl: null, contractEnded: false };
const PublicIdentityContext = createContext<PublicIdentity>(VAZIA);

/** UM listener em system_settings/public_identity (leitura anonima). Fica FORA do gate de login. */
export function PublicIdentityProvider({ children }: { children: ReactNode }) {
  const [data, setData] = useState<PublicIdentityDoc | null>(null);

  useEffect(
    () =>
      subscribePublicIdentity(setData, (err) => {
        console.warn('[identidade]', err.message);
        setData(null);
      }),
    [],
  );

  const identity = useMemo(() => toPublicIdentity(data, storageBucket()), [data]);

  useEffect(() => {
    document.title = windowTitle(identity.clinicName);
  }, [identity.clinicName]);

  return <PublicIdentityContext.Provider value={identity}>{children}</PublicIdentityContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function usePublicIdentity(): PublicIdentity {
  return useContext(PublicIdentityContext);
}
